/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { countryControllerGetAll } from '../fn/country/country-controller-get-all';
import { CountryControllerGetAll$Params } from '../fn/country/country-controller-get-all';
import { countryControllerGetAllCurrencies } from '../fn/country/country-controller-get-all-currencies';
import { CountryControllerGetAllCurrencies$Params } from '../fn/country/country-controller-get-all-currencies';
import { CountryResponse } from '../models/country-response';

@Injectable({ providedIn: 'root' })
export class CountryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `countryControllerGetAll()` */
  static readonly CountryControllerGetAllPath = '/country';

  /**
   * Restituisce l'elenco dei paesi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetAll$Response(params?: CountryControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>> {
    return countryControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei paesi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetAll(params?: CountryControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CountryResponse;
}> {
    return this.countryControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>): BaseResponse & {
'data'?: CountryResponse;
} => r.body)
    );
  }

  /** Path part for operation `countryControllerGetAllCurrencies()` */
  static readonly CountryControllerGetAllCurrenciesPath = '/country/currencies';

  /**
   * Restituisce l'elenco delle valute dei paesi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerGetAllCurrencies()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetAllCurrencies$Response(params?: CountryControllerGetAllCurrencies$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>> {
    return countryControllerGetAllCurrencies(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle valute dei paesi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerGetAllCurrencies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetAllCurrencies(params?: CountryControllerGetAllCurrencies$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CountryResponse;
}> {
    return this.countryControllerGetAllCurrencies$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>): BaseResponse & {
'data'?: CountryResponse;
} => r.body)
    );
  }

}
